export const MessageType = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
} as const;

export type MessageType = (typeof MessageType)[keyof typeof MessageType];
